import type { SiteContent } from '@/types/Contenu'
import { PREDICATIONS_INITIALES } from '@/data/predications'
import { EQUIPE_INITIALE } from '@/data/equipe'
import { MOT_DU_PASTEUR_INITIAL } from '@/data/motDuPasteur'
import { DONS_INITIAUX } from '@/data/donations'
import { CONTACT_INITIAL } from '@/data/contact'

// Contenu affiché tant que rien n'a été modifié depuis l'admin (et en attendant le backend).
export const DEFAULT_CONTENT: SiteContent = {
  predications: PREDICATIONS_INITIALES,
  equipe: EQUIPE_INITIALE,
  motDuPasteur: MOT_DU_PASTEUR_INITIAL,
  dons: DONS_INITIAUX,
  contact: CONTACT_INITIAL,
}
